export const SEARCH_INPUT_CHANGED = 'SEARCH_INPUT_CHANGED';
export const DOCUMENTATION_SEARCH_STARTED = 'DOCUMENTATION_SEARCH_STARTED';
export const DOCUMENTATION_SEARCH_SUCCESS = 'DOCUMENTATION_SEARCH_SUCCESS';
export const DOCUMENTATION_SEARCH_FAILIED = 'DOCUMENTATION_SEARCH_FAILIED';
export const RESET_FOUND_DOCUMENTATION = 'RESET_FOUND_DOCUMENTATION';
